import script from "./CreateTeamPop.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTeamPop.vue?vue&type=script&setup=true&lang=js"

import "./CreateTeamPop.vue?vue&type=style&index=0&id=1019b3be&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1019b3be"]])

export default __exports__